function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M179.00036.51745l-.00003 328.24182c-23.88794-1.3675-47.6724-8.4512-69.3574-18.42293-33.39682-15.5041-61.66972-38.0196-81.96532-68.03038-20.1912-29.92192-32.3094-67.33912-26.00237-101.05312 6.40273-33.72387 31.22199-63.63591 60.28653-86.7538C91.122 31.29228 124.42313 14.97841 167.27615 3.47378c3.83934-1.03073 7.75541-2.02215 11.7242-2.95633z",
  fill: "#FFF",
  fillRule: "evenodd"
});

var SvgPageLinkShape = function SvgPageLinkShape(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 179 329",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPageLinkShape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/page-link-shape.dab34e60.svg";
export { ForwardRef as ReactComponent };